import { useCallback, useMemo } from 'react';
import { isString, isUndefined } from 'lodash';
import { useLocalstorageState } from 'rooks';

import { timeframeItems } from 'components/Timeframe';
import { snakeKeys } from 'helpers/common';
import { formatISO } from 'date-fns';

const useTimeframeLS = (props = {}) => {
  const { onChange: onChangeProp, value } = props;

  const [timeframeLS, setTimeframeLS] = useLocalstorageState(
    'settings:timeframe',
    timeframeItems[0].value,
  );

  const timeframe = useMemo(() => {
    const neededValue = isUndefined(value) ? timeframeLS : value;
    if (!neededValue?.length) return neededValue;

    if (isString(neededValue?.[0])) {
      return [new Date(neededValue?.[0]), new Date(neededValue?.[1])];
    }

    return neededValue;
  }, [timeframeLS, value]);

  const onChange = useCallback(
    (newValue, ...args) => {
      setTimeframeLS(newValue);
      onChangeProp?.(newValue, ...args);
    },
    [onChangeProp, setTimeframeLS],
  );

  return {
    timeframe,
    onTimeframeChange: onChange,
  };
};

const useTimeframeDateStrings = (timeframe) => {
  const result = useMemo(() => {
    if (!timeframe?.length) return;

    return snakeKeys({
      timeframeAfter: timeframe[0]
        ? formatISO(timeframe[0], { representation: 'date' })
        : '',
      timeframeBefore: timeframe[1]
        ? formatISO(timeframe[1], { representation: 'date' })
        : '',
    });
  }, [timeframe]);

  return result;
};

export { useTimeframeLS, useTimeframeDateStrings };
